module.exports = __webpack_public_path__ + "static/media/application_approved.205215b0.svg";